import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';


Font.register({
  family: 'Lato',
  src: '../../themes/custom/dsj/fonts/Lato-Medium.ttf',
  fontStyle: 'normal',
  fontWeight: 'normal',
});

Font.register({
  family: 'Lato',
  src: '../../themes/custom/dsj/fonts/Lato-Bold.ttf',
  fontStyle: 'normal',
  fontWeight: 'bold',
});
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    paddingTop:100,
    paddingBottom:70,
    fontFamily: 'Lato',
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  big : {
    marginTop: 10,
    marginBottom: 15,
    fontSize: 20,
    color: '#FEC100',
    fontWeight: 'bold',
  },
  medium : {
    display: 'block',
    fontWeight: 'bold',
    fontSize: 10,
    marginBottom: 5,
  },
  small : {
    display: 'block',
    fontSize: 8,
  },
  fixedHeader: {
    position: 'absolute',
    top: 20,
    left: 20,
    width: 110,
    height: 200,
  },
  logo: {
    width: 110,
    height: 200,
  }
});


const FixedHeader = (props) => (
  <View
    style={styles.fixedHeader}
    fixed
  >
    <Image
      style={styles.image}
      src={props.lang === 'fr' ? "../../themes/custom/dsj/images/home-overlay-yellow-fr.png":"../../themes/custom/dsj/images/home-overlay-yellow.png"}
    />
  </View>
);

// Create Document Component
const MyDocument = ({searchCategories, lang}) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <FixedHeader lang={lang} />
      <View style={styles.section}>
        {
          searchCategories.map((result, index) => {
            return (
                <View key={index}>
                  <Text style={styles.big}>{result.title}</Text>
                  {
                    result.results.map((item, subindex) => {
                      let address = item.address.replace(/(<([^>]+)>)/gi, "")
                      address = address.replace(/\n/gi, " ")
                      address = address.replace(/ +(?= )/g,'');
                      return (
                        <View style={{marginBottom: 15}} wrap={false} key={"s"+subindex}>
                          <Text style={styles.medium}>{item.title}</Text>
                          <Text style={styles.small}>{item.phone}</Text>
                          <Text style={styles.small}>{address}</Text>
                          <Text style={styles.small}>{item.website}</Text>
                        </View>
                      )
                    })
                  }
                </View>)
          })
        }
      </View>
    </Page>
  </Document>
);

export default MyDocument;
